import { useReactFlow } from '@xyflow/react';
import useWorkflowStore from '../store';
import { newNode } from '../nodes/utils';

export const useAddNoNodeTasks = () => {
    const store = useWorkflowStore();
    const { addNodes } = useReactFlow();
    const { setNoNodeTasks } = store;
    const no_node_tasks = useWorkflowStore(state => state.no_node_tasks);

    const addNoNodeTasks = () => {
        const minX = Math.min(...store.nodes.map(node => node.position.x));
        const maxY = Math.max(...store.nodes.map(node => node.position.y));
        const newNodes = no_node_tasks.map((task, index) => {
            return newNode({
                type: 'task',
                position: { x: minX + index * 100, y: maxY + 100 },
                data: task,
            });
        });

        addNodes(newNodes);
        setNoNodeTasks([]);
    };

    return { no_node_tasks, addNoNodeTasks };
};
